import { DecimalInput } from './DecimalInput';

interface LossInputProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
  highlight?: boolean;
}

export function LossInput({ label, value, onChange, highlight = false }: LossInputProps) {
  return (
    <div className="space-y-1.5">
      <label className="block text-xs font-medium text-slate-600">
        {label}
      </label>
      
      <DecimalInput
        value={value}
        onChange={onChange}
        className={`w-full px-3 py-2 border border-slate-300 rounded-lg transition-all ${
          highlight ? 'ring-2 ring-amber-400 border-amber-400 bg-amber-50' : ''
        }`}
        placeholder="0"
      />
    </div>
  );
}